import {createContext} from "react";

export interface UserInfo {
    username: string | undefined,
    csrfToken: string | undefined
}

const UserInfoContext = createContext<UserInfo | null>(null);
export default UserInfoContext;